<template>
    <div>
        <span v-for='(item, index) of detail.toDepartment' :key='item.id'>
            {{item.name}}
            {{detail.toDepartment.length - 1 === index ? '' : ', '}}
        </span>
    </div>
</template>

<script>
export default {
    props: {
        detail: Object
    }
}
</script>

<style lang="scss" scoped>
    .el-form-item {
        img {
            vertical-align: middle;
            margin-left: 5px;
        }
    }
</style>
